import { Navigate, useParams } from "react-router-dom";

/** Project home is Files. Guide is a next-up strip on that tab, not a competing board. */
export function HomePage() {
  const { orgSlug, projectSlug } = useParams();
  if (!orgSlug || !projectSlug) return <Navigate to="/" replace />;
  return <Navigate to={`/o/${orgSlug}/p/${projectSlug}/files`} replace />;
}
